import React from 'react';

import {fetchEventSpeakers} from '../../data/fetch';
import {useStoredDataChanged} from './useStoredDataChanged';
import Loader from './Loader';

const LoadSpeakers = ({eventId, children}) => {
    useStoredDataChanged();
    return (
        <Loader skipSpinner={state => state.events[eventId]?.speakers.loaded} promises={[fetchEventSpeakers(eventId)]}>
            {children}
        </Loader>
    );
};

export default LoadSpeakers;
